import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'
import { BrowserRouter, Route } from 'react-router-dom'
import ContextProvider from './common-context'
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { createMsalConfig } from "./authConfig";

if (process.env.NODE_ENV === 'production') {
    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}
}

const Root = () => {
    const [msalInstance, setMsalInstance] = useState(null);
  
    useEffect(() => {
      const init = async () => {
        let clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
        let tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '';
  
        // Fallback to fetch
        if (!clientId || !tenantId) {
          try {
            const res = await fetch('https://jsonplaceholder.typicode.com/todos/1');
            const json = await res.json();
            console.log(json);
  
            // สมมุติได้จาก response จริง
            clientId = '123';
            tenantId = '456';
          } catch (err) {
            console.error('Failed to fetch config', err);
            return;
          }
        }
  
        const instance = new PublicClientApplication(createMsalConfig(clientId, tenantId));
        setMsalInstance(instance);
      };
  
      init();
    }, []);
  
    if (!msalInstance) {
      return <div></div>;
    }
  
    return (
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <ContextProvider>
            <BrowserRouter>
              <Route component={App} />
            </BrowserRouter>
          </ContextProvider>
        </MsalProvider>
      </Provider>
    );
};

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
